<template>
    <v-container fluid>
      <div class="esign-backbar">
        <v-btn text class="esign-back-btn" @click="back">
          <v-icon left>mdi-arrow-left</v-icon> Kembali
        </v-btn>
      </div>
      <v-row class="esign-detail-grid">
        <v-col cols="12" :lg="linimasa.length > 0 ? 7 : 12">
        <material-card
        color="primary"
        title="Detail Dokumen"
        class="card-wrapper"
        >
          <!-- Document actions next to the title; destructive ones live in the ⋮ menu -->
          <template v-if="arsip && arsip.flag_aktif" v-slot:head-actions>
            <v-btn outlined color="primary" @click="preview">
              <v-icon left small>mdi-eye-outline</v-icon>Preview Dokumen
            </v-btn>
            <v-btn v-if="idStatus == 3" depressed color="primary" @click="download()">
              <v-icon left small>mdi-download</v-icon>Download
            </v-btn>
            <v-btn v-if="idStatus == 5 && peran=='A02' && allow_reject" outlined color="primary" @click="confirm_reject_dialog = true">
              Konfirm Tolak
            </v-btn>
            <v-btn v-if="idStatus == 5 && peran=='A02'" outlined color="primary" @click="deny_reject_dialog = true">
              Sanggah Tolak
            </v-btn>
            <v-menu v-if="peran=='A01' || (idStatus != 3 && idStatus != 4 && peran=='A02')" offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon aria-label="Aksi lainnya" v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item v-if="peran=='A01'" @click="nonaktif_dialog = true">
                  <v-list-item-icon><v-icon color="error">mdi-file-cancel-outline</v-icon></v-list-item-icon>
                  <v-list-item-title class="error--text">Nonaktifkan dokumen</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="idStatus != 3 && idStatus != 4 && peran=='A02'" @click="cancel_dialog = true">
                  <v-list-item-icon><v-icon color="error">mdi-close-circle-outline</v-icon></v-list-item-icon>
                  <v-list-item-title class="error--text">Batalkan pengajuan</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
            <div v-if="this.arsip">
                <div class="esign-detail">
                  <div class="row">
                    <div class="col-4" @click="testbsre(1)">
                      <p class="label font-weight-bold mb-1">Nomor Pengajuan</p>
                    </div>
                    <div class="col-8" @click="testbsre(0)">
                      <p class="label">{{ signForm.nomor_pengajuan }}</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      <p class="label font-weight-bold mb-1">Tanggal Pengajuan</p>
                    </div>
                    <div class="col-8">
                      <p class="label">{{ tanggalPengajuan }}</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      <p class="label font-weight-bold mb-1">Nomor Surat</p>
                    </div>
                    <div class="col-8">
                      <p class="label">{{ signForm.nomor_surat }}</p>
                    </div>
                  </div>
                  <div class="row">
                      <div class="col-4">
                        <p class="label font-weight-bold mb-1">Nama Pengaju</p>
                      </div>
                      <div class="col-8">
                        <p class="label">{{ signForm.username_pengaju }}</p>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-4">
                        <p class="label font-weight-bold mb-1">Jenis Dokumen</p>
                      </div>
                      <div class="col-8">
                        <p class="label">{{ jenisDokumen }}</p>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-4">
                        <p class="label font-weight-bold mb-1">Organisasi</p>
                      </div>
                      <div class="col-8">
                        <p class="label">{{ organisasi }}</p>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-4">
                        <p class="label font-weight-bold mb-1">File Dokumen</p>
                      </div>
                      <div class="col-8">
                        <p class="label">{{ fileDokumen }}</p>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-4">
                        <p class="label font-weight-bold mb-1">Lokasi Dokumen</p>
                      </div>
                      <div class="col-8">
                        <p class="label">{{ lokasiDokumen }}</p>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-4">
                        <p class="label font-weight-bold mb-1">Workflow Persetujuan</p>
                      </div>
                      <div class="col-8">
                        <p class="label">{{ workflowPersetujuan }}</p>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-4">
                        <p class="label font-weight-bold mb-1">Tingkat Kerahasiaan</p>
                      </div>
                      <div class="col-8">
                        <p class="label">{{ tingkatKerahasiaan }}</p>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-4">
                        <p class="label font-weight-bold mb-1">Status</p>
                      </div>
                      <div class="col-8">
                        <esign-status-tag :tone="['neutral', 'warning', 'success', 'danger', 'warning'][idStatus - 1]" :value="status" />
                      </div>
                  </div>
                  <div class="row" v-if="idStatus == 5">
                    <div class="col-4">
                        <p class="label font-weight-bold mb-1">Keterangan</p>
                      </div>
                      <div class="col-8">
                        <p class="label">{{ memoPembatalan }}</p>
                      </div>
                  </div>
                  <div class="row" v-if="catatanSanggahTolak != ''">
                    <div class="col-4">
                        <p class="label font-weight-bold mb-1">Catatan Sanggah Penolakan</p>
                      </div>
                      <div class="col-8">
                        <p class="label">{{ catatanSanggahTolak }}</p>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-4">
                        <p class="label font-weight-bold mb-1">Keaktifan</p>
                      </div>
                      <div class="col-8">
                        <esign-status-tag :tone="arsip.flag_aktif ? 'success' : 'neutral'" :value="arsip.flag_aktif ? 'Aktif' : 'Tidak Aktif'" />
                      </div>
                  </div>
                  <div v-if="!arsip.flag_aktif" class="row">
                      <div class="col-4">
                        <p class="label font-weight-bold mb-1">Keterangan Nonaktif</p>
                      </div>
                      <div class="col-8">
                        <p class="label">{{ arsip.keterangan_flag_aktif }}</p>
                      </div>
                  </div>
                </div>

                <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="8000" :top="true">
                  {{ snackbarText }}
                  <v-btn dark text @click="snackbar = false">Close</v-btn>
                </v-snackbar>
                <!-- {{ memoPembatalan }} -->
                <!-- Signer: sign with passphrase, or reject -->
                <v-form v-if="peran=='A03' && isEligible && idStatus != 3 && idStatus != 4 && idStatus != 5 && arsip.flag_aktif" class="esign-sign-form" @submit.prevent="sign()">
                  <h3 class="esign-subhead">Tanda tangan dokumen</h3>
                  <label class="esign-field-label" for="signPassphrase">Passphrase</label>
                  <div class="esign-sign-form__row">
                    <v-text-field
                      id="signPassphrase"
                      outlined
                      dense
                      hide-details
                      placeholder="Masukkan passphrase"
                      v-model="signForm.passphrase"
                      :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                      :type="fieldTypes"
                      @keydown.enter.prevent="sign()"
                      autocomplete="off"
                      @click:append="peekPassword"
                      @focus="handleType"
                      @blur="handleType"
                    />
                    <v-btn depressed color="primary" @click="sign()">{{ttdText}}</v-btn>
                    <v-btn outlined color="error" @click="reject_dialog = true">Menolak</v-btn>
                  </div>
                </v-form>
                <v-row>
                  <v-dialog
                    v-model="dialog"
                    persistent
                    style="z-index:99999;">
                    <v-card>
                      <v-card-title class="text-h5 grey lighten-2">
                        Preview Dokumen
                      </v-card-title>

                      <v-card-text>
                        <DragAndDrop :source="sourcePdf" :ttd-items="imagePdfItems" :dialog="dialog" :permission="'Detail'">
                        </DragAndDrop>
                      </v-card-text>

                      <v-divider></v-divider>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          text
                          @click="dialog = false"
                        >
                          Tutup
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
            </v-row>
            <v-dialog transition="scale-transition" origin="center center" v-model="confirm_reject_dialog" max-width="800px">
              <v-card class="card-modal" color="error">
                <v-card-title>
                </v-card-title>
                <v-card-text>
                  <v-row align="center">
                    <v-col cols="2">
                      <v-icon style="font-size: 80px;" color="white">
                          mdi-alert
                        </v-icon>
                    </v-col>
                    <v-col class="text-h6 white--text" cols="10">
                      Apakah anda yakin ingin menyetujui penolakan?<br><br>
                      <strong>Tindakan ini dapat membuat penandatangan yang menolak terhapus dari data penandatangan</strong>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn :disabled="batalConfirmReject" large @click="confirm_reject_dialog = false"><b>Batal</b></v-btn>
                  <v-btn :loading="loadingConfirmReject" large white--text color="black" dark @click="proceedConfirmReject()"><b>Ya</b></v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog transition="scale-transition" origin="center center" v-model="deny_reject_dialog" max-width="800px">
              <v-card class="card-modal" color="error">
                <v-card-title>
                </v-card-title>
                <v-card-text>
                  <v-row align="center">
                    <v-col cols="2">
                      <v-icon style="font-size: 80px;" color="white">
                          mdi-alert
                        </v-icon>
                    </v-col>
                    <v-col class="text-h6 white--text" cols="10">
                      Apakah anda yakin ingin menyanggah penolakan?<br><br>
                      <strong>Tindakan ini dapat memasukkan kembali penandatangan yang menolak ke dalam data penandatangan</strong>
                    </v-col>
                  </v-row><br>
                  <v-row>
                    <v-col cols="12"><p class="white--text label font-weight-bold mb-1">Ketikkan Catatan untuk Penandatangan yang Menolak</p></v-col>
                    <v-col>
                    <v-text-field
                      background-color="white"
                      outlined
                      dense
                      placeholder="Catatan"
                      v-model="keterangan_sanggah_tolak"/>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn :disabled="batalDenyReject" large @click="deny_reject_dialog = false"><b>Batal</b></v-btn>
                  <v-btn :loading="loadingDenyReject" large white--text color="black" dark @click="proceedDenyReject()"><b>Ya</b></v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog persistent transition="scale-transition" origin="center center" v-model="cancel_dialog" max-width="800px">
              <v-card class="card-modal" color="error">
                <v-card-title>
                </v-card-title>
                <v-card-text>
                  <v-row align="center">
                    <v-col cols="2">
                      <v-icon style="font-size: 80px;" color="white">
                          mdi-alert
                        </v-icon>
                    </v-col>
                    <v-col class="text-h6 white--text" cols="10">
                      Apakah anda yakin ingin membatalkan pengajuan <b>{{ jenisDokumen }}</b> dengan nomor pengajuan <b> {{signForm.nomor_pengajuan}}</b>?<br><br>
                      <strong>Tindakan ini dapat menghapus pengajuan dan mengulangi proses pengajuan dokumen dari awal</strong>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn :disabled="batalCancel" large @click="cancel_dialog = false"><b>Batal</b></v-btn>
                  <v-btn :loading="loadingCancel" large white--text color="black" dark @click="proceedCancel()"><b>Ya</b></v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog persistent transition="scale-transition" origin="center center" v-model="reject_dialog" max-width="800px">
              <v-card class="card-modal" color="error">
                <v-card-title>
                </v-card-title>
                <v-card-text>
                  <v-row align="center">
                    <v-col cols="2">
                      <v-icon style="font-size: 80px;" color="white">
                          mdi-alert
                        </v-icon>
                    </v-col>
                    <v-col class="text-h6 white--text" cols="10">
                      Apakah anda yakin ingin menolak <b>{{ jenisDokumen }}</b> dengan nomor pengajuan <b> {{signForm.nomor_pengajuan}}</b>?<br><br>
                      <strong>Tindakan ini dapat menghapus data Anda sebagai pemaraf/penandatangan dokumen ini</strong>
                    </v-col>
                  </v-row><br>
                  <v-row>
                    <v-col cols="12"><p class="white--text label font-weight-bold mb-1">Ketikkan Alasan Penolakan untuk Pengaju</p></v-col>
                    <v-col>
                    <v-text-field
                      background-color="white"
                      outlined
                      dense
                      placeholder="Memo Pembatalan"
                      v-model="rejectRequest.keterangan"
                      @keydown.enter="proceedReject()"/>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn :disabled="batalReject" large @click="reject_dialog = false"><b>Batal</b></v-btn>
                  <v-btn :loading="loadingReject" large white--text color="black" dark @click="proceedReject()"><b>Ya</b></v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog transition="scale-transition" origin="center center" v-model="nonaktif_dialog" max-width="800px">
              <v-card class="card-modal" color="error">
                <v-card-title>
                </v-card-title>
                <v-card-text>
                  <v-row align="center">
                    <v-col cols="2">
                      <v-icon style="font-size: 80px;" color="white">
                          mdi-alert
                        </v-icon>
                    </v-col>
                    <v-col class="text-h6 white--text" cols="10">
                      Apakah anda yakin ingin menonaktifkan dokumen ini?<br><br>
                      <strong>Tindakan ini dapat membuat dokumen tidak valid (inaktif) meskipun telah ditandatangi secara BSrE</strong>
                    </v-col>
                  </v-row><br>
                  <v-row>
                    <v-col cols="12"><p class="white--text label font-weight-bold mb-1">Ketikkan Catatan Penonaktifan</p></v-col>
                    <v-col>
                    <v-text-field
                      background-color="white"
                      outlined
                      dense
                      placeholder="Catatan"
                      v-model="catatan_nonaktif"/>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn :disabled="batalNonaktif" large @click="nonaktif_dialog = false"><b>Batal</b></v-btn>
                  <v-btn :loading="loadingNonaktif" large white--text color="black" dark @click="proceedNonaktif()"><b>Ya</b></v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            
            </div>
            <div v-else>
                <h4 class="text-center">Tidak ada data</h4>
            </div>  
        </material-card>
        </v-col>
        <v-col v-if="linimasa.length > 0" cols="12" lg="5">
          <material-card
            color="primary"
            title="Riwayat Penandatanganan"
            class="card-wrapper esign-timeline-card"
          >
            <div class="esign-timeline">
              <v-timeline align-top dense>
                        <v-timeline-item style="padding-bottom:15px" dark fill-dot color="cyan">
                          <!-- <template v-slot:icon>
                            <v-icon dark size="30">mdi-dots-vertical</v-icon>
                          </template> -->
                          <v-row justify="space-between">
                            <v-col cols="5">
                              <v-chip color="cyan" label>
                                Dokumen diajukan
                              </v-chip>
                              <div class="text-caption">{{ tanggalPengajuan }}</div>
                            </v-col>
                            <v-col cols="3">
                              <p><strong>{{ signForm.username_pengaju }}</strong></p>
                              <!-- <div class="text-caption"></div> -->
                            </v-col>
                            <v-col cols="4">
                              <v-chip>
                                <v-icon>mdi-send</v-icon>&nbsp;Pengaju
                              </v-chip>
                            </v-col>
                          </v-row><v-divider light class="mb-2" />
                        </v-timeline-item>
                        <v-timeline-item style="padding-bottom:15px" dark fill-dot v-for="(item, i) in linimasa" :key="i" :color="item.color">
                          <template v-slot:icon>
                            <v-icon dark size="30">{{ item.icon }}</v-icon>
                          </template>
                          <v-row class="justify-center" v-if="item.posisi && workflowPersetujuan == 'Berjenjang'"><v-chip class="mb-3" color="green" label>{{ item.posisi }}</v-chip></v-row>
                          <v-row justify="space-between">
                            <v-col cols="5">
                              <!-- <p v-if="item.posisi != ''">
                                <v-chip small v-if="workflowPersetujuan != 'Grup'" class="black--text" :color="item.color" label>
                                  {{ item.posisi }}
                                </v-chip>&nbsp;
                              </p> -->
                              <v-chip small v-if="workflowPersetujuan != 'Grup'" :color="item.color" label>
                                {{ item.no }}
                              </v-chip>&nbsp;
                              <strong>{{ item.deskripsi }}</strong>
                              <div class="text-caption"><strong>{{ item.last_update }}</strong></div>
                            </v-col>
                            <v-col cols="3">
                              <p><strong>{{ item.pengguna.nama_lengkap }}</strong></p>
                              <div class="text-caption">{{ item.jabatan }}</div>
                            </v-col>
                            <v-col cols="4">
                              <v-chip>
                                <v-icon>{{item.icon_ttd}}</v-icon>&nbsp;{{ item.tipe }}
                              </v-chip>
                            </v-col>
                          </v-row><v-divider light class="mb-4" />
                        </v-timeline-item>
                        <v-timeline-item dark fill-dot v-if="idStatus == 3" color="primary">
                          <template v-slot:icon>
                            <v-icon dark size="30">mdi-check-bold</v-icon>
                          </template>
                          <v-row justify="space-between">
                            <v-col cols="5">
                              <v-chip color="primary" label>Selesai</v-chip>
                            </v-col>
                          </v-row>
                        </v-timeline-item>
                      </v-timeline>
            </div>
          </material-card>
        </v-col>
      </v-row>
        <v-overlay
          :opacity="0.5"
          :value="overlay"
        >
          <v-progress-circular indeterminate size="64">
            Loading...
          </v-progress-circular>
        </v-overlay>
    </v-container>
  </template>

<script>
import { apiServer, docConverter } from "../../setup-axios";
import DragAndDrop from "../jenisDokumenOrganisasi/DragAndDrop.vue";
import { stampPath } from '../../config/env'
import { qrPlaceHolder } from '../../config/env'
import { bsreDisclaimer } from '../../config/env'
import { parafPath } from '../../config/env'
import { signPath } from '../../config/env'
import { documentPath } from '../../config/env'


var moment = require('moment');
export default {
  data: () => ({
    page: 1,
    numPages: 0,
    search: "",
    snackbar: false,
    snackbarText: "",
    snackbarColor: "",
    isLoading: true,
    batalCancel: false,
    loadingCancel: false,
    batalConfirmReject: false,
    loadingConfirmReject: false,
    batalDenyReject: false,
    loadingDenyReject: false,
    batalReject: false,
    loadingReject: false,
    batalNonaktif: false,
    loadingNonaktif:false,
    showPassword: false,
    arsip: null,
    tanggalPengajuan:"",
    jenisDokumen: "",
    organisasi: "",
    fileStampOrganisasi: "",
    fileDokumen: "",
    lokasiDokumen: "",
    idStatus: null,
    status: "",
    daftarPemaraf: [],
    daftarPenandatangan: [],
    chosenIdJenisTtds: [],
    chosenJenisTtds: [],
    items: [],
    linimasa:[],
    overlay: false,
    signForm: {
      id_arsip_dokumen: null,
      nomor_surat: "",
      nomor_pengajuan: "",
      id_jenis_dokumen_organisasi: null,
      id_ttd_arsip_dokumen: null,
      username_pengaju: "",
      id_user_login: null,
      username_login: "",
      passphrase: ""
    },
    allow_reject: true,
    pengajuForm: {
      id_ttd_arsip_dokumen: null,
      next_id_ttd_arsip_dokumen: -1,
      id_arsip_dokumen: null
    },
    keterangan_sanggah_tolak: "",
    rejectRequest: {
      id_ttd_arsip_dokumen: null,
      next_id_ttd_arsip_dokumen: -1,
      username_pengaju: "",
      keterangan: "",
      flag_visual:null,
      nama_jenis_dokumen: "",
      id_arsip_dokumen: null
    },
    sourcePdf: null,
    finalPdf: null,
    dialog: false,
    catatan_nonaktif: "",
    nonaktif_dialog: false,
    cancel_dialog: false,
    confirm_reject_dialog: false,
    deny_reject_dialog: false,
    reject_dialog:false,
    sign_dialog: false,
    // keterangan: "",
    memoPembatalan:"",
    catatanSanggahTolak: "",
    headers: [
      { text: "Tanggal Pengajuan", value: "tanggal_pengajuan" },
      { text: "Jenis Dokumen", value: "jenis_dokumen"},
      { text: "Nama Pengaju", value: "username_pengaju"},
      { text: "Status", value: "status"},
      { text: "Aksi", value: "action", sortable: false},
    ],
    eligiblePengguna: [],
    options: {},
    totalData: 0,
    peran: "",
    user: null,
    workflowPersetujuan:"",
    isEligible: false,
    tingkatKerahasiaan : "",
    idTingkatKerahasiaan: null,
    errorMessagePassphrase: "",
    dragAndDropKey: 0,
    bsre_text: "",
    bsre_text_img: "",
    bsre_user_text: "",
    show_bsre: false,
    api_path: "",
    api_path_sign: "",
    ttdText: "",
    blob_data: null,
    blob_final_data: null,
    imagePdfItems: []
  }),

  watch: {
    options: {
      handler() {
        this.getData()
      },
      deep: true
    },
  },
  components :{ DragAndDrop },

  async created() {
    // this.dragAndDropKey += 1
    // console.log("this.dragAndDropKey " + this.dragAndDropKey)
    // this.$forceUpdate();
    this.peran =localStorage.getItem("currentPeran"),
    this.user= JSON.parse(localStorage.getItem("user"))
    if (this.$store.state.snackbar.snackbarText != null) {
      this.showMessage()
    }
    await this.getDropdownJenisTtd()
    if (this.peran == 'A02' || this.peran == 'A03') {
      await this.getListEligibleIdPengguna(this.$route.params.id)
      if (!this.eligiblePengguna.includes(this.user.id)) {
        this.$router.push('/403');
      }
    }
    this.getData(this.$route.params.id)
  },

  methods: {
    handleType(event) {
      const { srcElement, type } = event;
      const { name, value } = srcElement;
      // console.log("name: ", name)
      // console.log("value: ", value)
      if(type === 'blur' && !value) {
        this.fieldTypes = 'text'
      } else {
        if (value=="") {
          this.fieldTypes = 'text'
        } else {
        // console.log("not blur and has value")
        this.fieldTypes = 'password'
        }
      }
      console.log("fieldTypes: ", this.fieldTypes)
    },
    peekPassword() {
      this.showPassword = !this.showPassword
      if (this.showPassword) {
          this.fieldTypes = 'text'
        } else {
          this.fieldTypes = 'password'
        }
    },
    async getListEligibleIdPengguna(id) {
      await apiServer
        .get("/arsip/eligible_pengguna/" + id)
        .then(response => {
          this.eligiblePengguna = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log("There was an error:", error.response.data.message); // Logs out the error
        });
    },
    getData(id) {
      this.isLoading = true;
      apiServer
        .get("/arsip/" + id)
        .then(async response => {
          this.arsip = response.data.data
          console.log("arsip", this.arsip)
          this.tanggalPengajuan = moment.utc(this.arsip.tanggal_entry).locale("id").format('DD-MM-YYYY HH:mm:ss')
          this.fileDokumen = this.arsip.file_dokumen
          
          this.lokasiDokumen = this.arsip.path_file
          if(localStorage.getItem("success") != null) {
            this.showSnackbar("success", localStorage.getItem("success"));
            localStorage.removeItem("success")
          }
          await this.getDetail()
          this.getDaftarPemaraf()
          this.getDaftarPenandatangan()
          this.getDaftarIdJenisTtds()
          this.loadLinimasa()
          await this.loadSourcePdf()
          await this.loadFinalPdf()
          //await this.loadImages()
          //await this.fillKoordinatTtdItems()
        })
        .catch(error => {
          console.log(error)
          console.log("There was an error:", error.response.data.message); // Logs out the error
        });
    },
    fillSignForm() {
        this.signForm.id_arsip_dokumen = this.arsip.id
        this.signForm.nomor_pengajuan = this.arsip.nomor_pengajuan      
        this.signForm.nomor_surat = this.arsip.nomor_surat    
        this.signForm.id_jenis_dokumen_organisasi = this.arsip.id_jenis_dokumen_organisasi
        this.signForm.username_pengaju = this.arsip.pengguna_entry
        this.signForm.id_user_login = this.user.id
        this.signForm.username_login = this.user.username
        this.signForm.nama_jenis_dokumen = this.jenisDokumen
        this.signForm.alur_persetujuan = this.workflowPersetujuan
        this.signForm.nik = this.user.pengguna.nik
    },
    formatTanggal(tanggal) {
      return moment.utc(tanggal).locale("id").format('DD-MM-YYYY HH:mm:ss')
    },
    testbsre(flag) {
      if (flag == 0) {
        this.show_bsre = false
      } 
      // else if (flag == 1) {
      //   this.show_bsre = true
      // }
    },
    async getDetail() {
      await apiServer
        .get("/arsip/detail_arsip", {
          params: {
            id_jenis_dokumen_organisasi: this.arsip.id_jenis_dokumen_organisasi,
            id_status_dokumen: this.arsip.id_status_dokumen
          }
        })
        .then(async response => {
          this.fileStampOrganisasi = response.data.data.organisasi.file_stamp
          this.organisasi = response.data.data.organisasi.nama
          this.jenisDokumen = response.data.data.jenis_dokumen.nama
          this.workflowPersetujuan = response.data.data.jenis_dokumen.alur_persetujuan
          this.idStatus = response.data.data.status.id
          this.status = response.data.data.status.nama
          this.idTingkatKerahasiaan = response.data.data.tingkat_kerahasiaan.id
          this.tingkatKerahasiaan = response.data.data.tingkat_kerahasiaan.nama
          this.fillSignForm()
          await this.getPenggunaFromArsip()
        })
        .catch(error => {
          console.log("There was an error:", error.response.data.message); // Logs out the error
        });
    },
    getDaftarPemaraf() {       
      this.arsip.ttd_arsip_dokumen.forEach((item, index) => {
        if (item.tipe_ttd == 1) {
          this.daftarPemaraf.push(item)
        }
      })
      this.daftarPemaraf.sort((a, b) => {
          return a.urutan_ttd - b.urutan_ttd;
      });
      this.daftarPemaraf.forEach((item, index) => {
        this.linimasa.push(item)
      })
    },
    getDaftarPenandatangan() {
      this.arsip.ttd_arsip_dokumen.forEach((item, index) => {
        if (item.tipe_ttd == 2) {
          this.daftarPenandatangan.push(item)
        }
      })
      this.daftarPenandatangan.sort((a, b) => {
          return a.urutan_ttd - b.urutan_ttd;
      });
      this.daftarPenandatangan.forEach((item, index) => {
        this.linimasa.push(item)
      })
    },
    getDaftarIdJenisTtds() {
      this.arsip.jenis_ttd_arsip_dokumen.forEach((item, index) => {
        // console.log(item.urutan_ttd)
        this.chosenIdJenisTtds.push(item.id_jenis_ttd)
      })
    },
    loadLinimasa() {
      console.log("linimasa:" + JSON.stringify(this.linimasa))
      this.linimasa.forEach((item, index) => {
        item.no=index+1
        //deskripsi
        if (item.flag_ttd == false && item.flag_urutan == true) {
          if (item.id_pengguna == this.user.id && this.peran=='A03' && this.idStatus != 5 && this.idStatus != 4) {
            item.posisi="Posisi Tandatangan saat ini"
            item.icon="mdi-play"
            item.color="green"
            if (item.tipe_ttd == 1) {
              item.deskripsi="Siap diparaf"
            } else if (item.tipe_ttd == 2){
              item.deskripsi="Siap ditandatangan"
            }
          } else if (this.idStatus == 5 && item.keterangan) {
            item.icon="mdi-cancel"
            item.color="error"
            item.deskripsi="Penolakan sedang direview"
          } else if (this.idStatus == 4 && item.keterangan) {
            item.icon="mdi-cancel"
            item.color="error"
            item.deskripsi="Menolak"
          } else {
            item.icon="mdi-clock"
            item.color="orange"
            if (item.tipe_ttd == 1) {
              item.deskripsi="Menunggu diparaf"
            } else if (item.tipe_ttd == 2){
              item.deskripsi="Menunggu ditandatangan"
            }
          }
        } else if (item.flag_ttd == false && item.flag_urutan == false){
          if (this.idStatus == 4) {
            if (item.keterangan) {
              item.icon="mdi-cancel"
              item.color="error"
              item.deskripsi="Menolak"
            } else  {
              item.icon="mdi-cancel"
              item.color="error"
              item.deskripsi="Dibatalkan"
            }
          } else {
            item.icon="mdi-clock"
            item.color="yellow"
            item.deskripsi="Menunggu Urutan"
          }
        } else if (item.keterangan) {
            item.icon="mdi-cancel"
            item.color="error"
            item.deskripsi="Menolak"
        } else if (item.flag_ttd == true) {
            item.icon="mdi-check-bold"
            item.color="primary"
            if (item.tipe_ttd == 1) {
              item.deskripsi="Telah diparaf"
            } else if (item.tipe_ttd == 2){
              item.deskripsi="Telah ditandatangan"
            }
        }
        //tipe ttd
        if (item.tipe_ttd == 1) {
          item.icon_ttd="mdi-pen"
          item.tipe="Pemaraf"
        } else {
          item.icon_ttd="mdi-fountain-pen-tip"
          item.tipe="Penandatangan"
        }
        //last update
        if (item.tanggal_update != null) {
          item.last_update = "Terakhir diupdate: " + this.formatTanggal(item.tanggal_update) 
        } else {
          item.last_update = ""
        }
        if (item.keterangan_sanggah_tolak) {
          if (item.id_pengguna == this.user.id || item.pengguna_entry == this.user.username) {
            this.catatanSanggahTolak = "Catatan sanggah penolakan dari pengaju " + item.pengguna_entry + ": " + item.keterangan_sanggah_tolak
          }
        }
        if (item.current_reject) {
          this.memoPembatalan += "Memo penolakan dari " + item.pengguna.nama_lengkap + ": " + item.keterangan
          this.pengajuForm.id_ttd_arsip_dokumen = item.id
          this.pengajuForm.id_arsip_dokumen = item.id_arsip_dokumen
          if (this.workflowPersetujuan == 'Berjenjang') {
            if (this.linimasa[index + 1]) {
              this.pengajuForm.next_id_ttd_arsip_dokumen = this.linimasa[index+1].id
            }
          }
          if (item.flag_visual) {
            this.allow_reject = false
          }
          // console.log("pengajuform", JSON.stringify(item))
        }
      })
    },
    close() {
      this.cancel_dialog = false
    },
    proceedCancel() {
      this.batalCancel = true
      this.loadingCancel = true
      apiServer
        .put("/arsip/cancel/" + this.$route.params.id)
        .then(response => {
          this.batalCancel = false
          this.loadingCancel = false
          localStorage.setItem('success', "Pengajuan dokumen berhasil dibatalkan")
          this.$router.go('/reject-dokumen');
        })
        .catch(error => {
          this.batalCancel = false
          this.loadingCancel = false
          console.log("There was an error:", error.response.data.message); // Logs out the error
        });
    },
    //konfirm
    // proceedConfirmReject() {
    //   console.log("this.pengajuForm " + JSON.stringify(this.pengajuForm))
    // },
    proceedConfirmReject() {
      this.batalConfirmReject = true
      this.loadingConfirmReject = true
      apiServer
        .put("/arsip/confirm_reject", this.pengajuForm)
        .then(response => {
          this.batalConfirmReject = false
          this.loadingConfirmReject = false
          console.log("confirm reject " + JSON.stringify(response.data))
          if (response.data.status == 'ok') {
            localStorage.setItem('success', response.data.message)
            this.$router.go('/reject-dokumen');
          }
        })
        .catch(error => {
          this.batalConfirmReject = false
          this.loadingConfirmReject = false
          console.log("There was an error:", error.response.data.message); // Logs out the error
        });
    },
    //sanggah
    proceedDenyReject() {
      this.batalDenyReject = true
      this.loadingDenyReject = true
      apiServer
        // .put("/arsip/deny_reject/" + this.pengajuForm.id_ttd_arsip_dokumen)
        .put("/arsip/deny_reject", {
          id_ttd_arsip_dokumen: this.pengajuForm.id_ttd_arsip_dokumen,
          keterangan_sanggah_tolak: this.keterangan_sanggah_tolak
        })
        .then(response => {
          this.batalDenyReject = false
          this.loadingDenyReject = false
          console.log("deny reject " + JSON.stringify(response.data))
          if (response.data.status == 'ok') {
            localStorage.setItem('success', response.data.message)
            // this.getNotifications()
            this.$router.go('/reject-dokumen');
          }
        })
        .catch(error => {
          this.batalDenyReject = false
          this.loadingDenyReject = false
          console.log("There was an error:", error.response.data.message); // Logs out the error
        });
    },
    proceedReject() {
      this.batalReject = true
      this.loadingReject = true
      this.rejectRequest.id_arsip_dokumen = this.signForm.id_arsip_dokumen
      this.rejectRequest.id_ttd_arsip_dokumen = this.signForm.id_ttd_arsip_dokumen
      this.rejectRequest.username_penandatangan = this.user.username
      this.rejectRequest.nama_jenis_dokumen = this.signForm.nama_jenis_dokumen
      if (this.signForm.id_ttd_arsip_dokumen != null && this.rejectRequest.keterangan != "") {
        apiServer
        .put("/arsip/reject", this.rejectRequest)
        .then(response => {
          this.batalReject = false
          this.loadingReject = false
          if (response.data.status == 'ok') {
            localStorage.setItem('success', "Permohonan tanda tangan berhasil ditolak dan memo berhasil disimpan")
            this.$router.go('/dokumen/detail/'+this.arsip.id);
          } else {
            this.showSnackbar("error", response.data.message)
          }
        })
        .catch(error => {
          this.batalReject = false
          this.loadingReject = false
          console.log("There was an error:", error.response.data.message); // Logs out the error
          this.showSnackbar("error", error.response.data.message)
        });
      } else {
        this.showSnackbar("error", "Memo pembatalan harus diisi.")
      }
    },
    proceedNonaktif() {
      this.batalNonaktif = true
      this.loadingNonaktif = true
      apiServer
        // .put("/arsip/deny_reject/" + this.pengajuForm.id_ttd_arsip_dokumen)
        .put("/arsip/nonaktif", {
          id: this.arsip.id,
          keterangan_flag_aktif: this.catatan_nonaktif
        })
        .then(response => {
          this.batalNonaktif = false
          this.loadingNonaktif = false
          console.log("nonaktif " + JSON.stringify(response.data))
          if (response.data.status == 'ok') {
            localStorage.setItem('success', response.data.message)
            this.$router.go('/dokumen/detail/'+this.arsip.id);
          }
        })
        .catch(error => {
          this.batalNonaktif = false
          this.loadingNonaktif = false
          console.log("There was an error:", error.response.data.message); // Logs out the error
        });
    },
    preview(){
      this.dialog = true
    },
    back() {
      this.$router.go(-1)
    },
    async getPenggunaFromArsip() {
      await apiServer
        .get("/arsip/pengguna_from_arsip", {
          params: {
            id_arsip_dokumen: this.arsip.id,
            tipe_ttd: -1,
            urutan_ttd: -1 
          }
        })
        .then(response => {
          let detail = response.data.data

          // console.log("detail: " +JSON.stringify(detail))
          // detail.forEach((item, index) => {
          if (this.workflowPersetujuan != 'Berjenjang') {
            for(let item of detail){
              if (item.id_penandatangan == this.user.id) {
                  console.log("match")
                  this.isEligible = true
                  this.signForm.id_ttd_arsip_dokumen = item.id_ttd_arsip_dokumen
                  if (item.tipe_ttd == 1) {
                    this.ttdText = "Paraf"
                  } else if (item.tipe_ttd == 2) {
                    this.ttdText = "Tanda Tangan"
                  }
                  this.rejectRequest.flag_visual = item.flag_visual
                  break
              } 
            }
          } else if (this.workflowPersetujuan == 'Berjenjang') {
            if (detail.length > 0) {
              if (this.user.id == detail[0].id_penandatangan && detail[0].flag_urutan) {
                console.log("eligible")
                this.isEligible = true
                this.signForm.id_ttd_arsip_dokumen = detail[0].id_ttd_arsip_dokumen
                if (detail[0].tipe_ttd == 1) {
                  this.ttdText = "Paraf"
                } else if (detail[0].tipe_ttd == 2) {
                  this.ttdText = "Tanda Tangan"
                }
                if (detail.length > 1) {
                  console.log("next")
                  this.rejectRequest.next_id_ttd_arsip_dokumen = detail[1].id_ttd_arsip_dokumen
                }
                this.rejectRequest.flag_visual = detail[0].flag_visual
              } else {
                  console.log("not eligible")
                  this.isEligible = false
              }
            }
          }
        })
        .catch(error => {
          console.log("error", this.signForm.id_ttd_arsip_dokumen)
          console.log("There was an error:", error.response.data.message); // Logs out the error
        });
    },
    validSignForm() {
      // console.log("id kerahasiaan: " + this.idTingkatKerahasiaan)
      let valid = false
        if (!this.isEligible) {
          this.showSnackbar("error", "Pengguna tidak dapat menandatangani dokumen ini.")
          this.overlay = false
        } else if (this.signForm.passphrase == "") {
          this.errorMessagePassphrase="Harap isi Passphrase"
          this.showSnackbar("error", this.errorMessagePassphrase)
          this.overlay = false
        } else if (this.signForm.id_ttd_arsip_dokumen == null){
          this.showSnackbar("error", "Proses penandatanganan tidak valid")
          this.overlay = false  
        } else {
          valid = true
        }
      return valid
    },
    async sign() {
      this.overlay = true
      if(this.validSignForm()) {
        // console.log("signform:" + JSON.stringify(this.signForm))
        apiServer
        .put("/arsip/sign", this.signForm)
        .then(response => {
          console.log(response.data.data)
          if (response.data.data == null) {
            localStorage.setItem('success', "Dokumen berhasil ditandatangani")
            this.$router.go('/dokumen/detail/'+this.arsip.id);
            this.overlay = false
          }
        })
        .catch(error => {
          console.log("There was an error:", error.response.data.message); // Logs out the error
          if (error.response.data.message.includes("urutan")) {
            console.log("error urutan")
            this.showSnackbar("error", error.response.data.message)
          } else {
            this.showSnackbar("error",error.response.data.message);
          }
          this.overlay = false
        });
      }   
    },
    async apiBsreSignImage() {
      this.overlay = true
      if(this.validSignForm()) {
        console.log("signform:" + JSON.stringify(this.signForm))
        apiServer
        .put("/arsip/api_bsre_sign_image", this.signForm)
        .then(response => {
          console.log("api bsre sign image"+JSON.stringify(response.data.data))
          this.bsre_text_img = response.data.data
          this.overlay = false
        })
        .catch(error => {
          console.log("There was an error:", error.response.data.message);
          this.showSnackbar("error",error.response.data.message);
          this.overlay = false
        });
      } 
    },
    async apiBsreSign() {
      this.overlay = true
      if(this.lokasiDokumen != '') {
        // console.log("signform:" + JSON.stringify(this.signForm))
        apiServer
        .get("/arsip/api_bsre_sign_test", {
          params: {
            id_user_login: this.user.id,
            path_file: this.lokasiDokumen,
            passphrase: ""
          }
        })
        .then(response => {
          console.log("api bsre sign"+JSON.stringify(response.data.data))
          this.bsre_text = "id_dokumen_bsre: " + response.data.data
          this.overlay = false
        })
        .catch(error => {
          console.log("There was an error:", error.response.data.message);
          this.showSnackbar("error",error.response.data.message);
          this.overlay = false
        });
      } 
    },
    async apiBsreGetUserStatus() {
      this.overlay = true
      apiServer
      .get("/arsip/api_bsre")
      .then(response => {
        console.log("api bsre get user status"+JSON.stringify(response.data.data))
        this.bsre_user_text = response.data.data
        this.overlay = false
      })
      .catch(error => {
        console.log("There was an error:", error.response.data.message);
        this.showSnackbar("error",error.response.data.message);
        this.overlay = false
      });
    },
    showSnackbar(color, message) {
      console.log("snack " + color + " - " + message);
      this.snackbar = true;
      this.snackbarText = message;
      this.snackbarColor = color;
    },
    showMessage () {
      this.showSnackbar(
          this.$store.state.snackbar.snackbarColor,
          this.$store.state.snackbar.snackbarText
      )
      this.$store.dispatch('setSnackbar', {
        snackbarColor: null,
        snackbarText: null,
      })
    },
    async loadSourcePdf() {
        this.sourcePdf = null
        const timestamp = new Date().getTime()
        if(this.lokasiDokumen) {
          await apiServer
            .get("/files/get-by-filepath?target_path="+this.lokasiDokumen.replaceAll("\\", "/")+"&type=download&timestamp="  + timestamp, {responseType: "blob"})
            .then(async response => {
              var bb = new Blob([response.data])
              var base64Pdf = await this.convertPdfToBase64(bb)
              const timestamp = new Date().getTime()
              await docConverter
                .post("/watermark-document" + '?timestamp=' + timestamp, {
                    pdfBase64: base64Pdf,
                    imgParameter: "",
                    username: JSON.parse(localStorage.getItem("user")).username
                  }, {responseType: "blob"})
                .then(response => {
                  bb = new Blob([response.data])
                })
                .catch(error => {
                  console.log(error)
                  console.log("There was an error:", error.response.data.message); // Logs out the error
                });
              const data = window.URL.createObjectURL(bb);
              this.blob_data = bb
              this.sourcePdf = data; 
            })
            .catch(error => {
              console.log(error + "/download-surat"+this.arsip.file_dokumen_signed)
              console.log("There was an error:", error.response.data.message); // Logs out the error
            });
        }
    },
    async loadFinalPdf() {
      this.finalPdf = null
        const timestamp = new Date().getTime()
        if(this.lokasiDokumen) {
          //alert(documentPath)
          apiServer
            .get("/files/get-by-filepath?target_path="+this.lokasiDokumen.replaceAll("\\", "/")+"&type=download&timestamp="  + timestamp, {responseType: "blob"})
            .then(response => {
              const bb = new Blob([response.data])
              const data = window.URL.createObjectURL(bb);
              this.blob_final_data = bb
              this.finalPdf = data; 
            })
            .catch(error => {
              console.log("There was an error:", error.response.data.message); // Logs out the error
            });
        }
    },
    // async download() {
    //     if(this.sourcePdf != null && this.fileDokumen) {
    //       const link = document.createElement('a');
    //       link.href = this.sourcePdf;
    //       link.setAttribute('download', this.fileDokumen);
    //       document.body.appendChild(link);
    //       link.click();
    //       window.URL.revokeObjectURL(this.blob_data)
    //     } else {
    //       this.showSnackbar("error","File not found, cannot download file");
    //     }
    // },
    async download() {
        if(this.finalPdf != null && this.fileDokumen) {
          const link = document.createElement('a');
          link.href = this.finalPdf;
          link.setAttribute('download', this.fileDokumen);
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(this.blob_final_data)
        } else {
          this.showSnackbar("error","File not found, cannot download file");
        }
    },
    async getDropdownJenisTtd() {
      await apiServer
          .get("/arsip/jenis_ttd")
          .then(response => {
            // console.log(response.data.data)
            var jenisTtds = response.data.data;
            this.chosenJenisTtds = []
            jenisTtds.forEach((item, index) => {
                  this.chosenJenisTtds.push({
                      id_jenis_ttd : item.Id,
                      nama: item.Nama,
                      flag_visual: false,
                  })
              })
          })
          .catch(error => {
            console.log("There was an error:", error.response.data.message); // Logs out the error
          });
    },
    // drag and drop related
    findElementById(id, array) {
        for(var ii = 0; ii < array.length; ii++) {
            if((id + '') === (array[ii].id + '')) {
                return array[ii]
            }
        }
        return null
    },
    // drag and drop related
    async loadImages() {
        //alert('load')
        await this.fillChosenJenisTtds()
        var newImagePdfItems = []
        
        await this.chosenJenisTtds.forEach((item, index) => {
            if(item.flag_visual === true) {
                newImagePdfItems.push({path: item.filePath, 
                    id: item.id})
            }
        })

        for(var ii = 0; ii < this.daftarPemaraf.length; ii++) {
            var item = this.daftarPemaraf[ii]
            var idPdfItem = item.pengguna.username + "_paraf"
            if(item.flag_visual === true) {  
              var pathBase64 = await this.loadBase64File(parafPath + '/' + item.pengguna.file_paraf)
              newImagePdfItems.push({path: pathBase64, 
                  id: idPdfItem})
            }
        }

        for(var ii = 0; ii < this.daftarPenandatangan.length; ii++) {
            var item = this.daftarPenandatangan[ii]
            var idPdfItem = item.pengguna.username + "_ttd"
            if(item.flag_visual === true) {  
              var pathBase64 = await this.loadBase64File(signPath + '/' + item.pengguna.file_ttd)
              newImagePdfItems.push({path: pathBase64, 
                  id: idPdfItem})
            }
        }

        this.imagePdfItems = newImagePdfItems
    },
    // set id, file path, and whether it's visual is shown on the pdf document using flag_visual
    async fillChosenJenisTtds() {
      // reset all flag visual of jenis ttd into false
      for(var ii = 0; ii < this.chosenJenisTtds.length; ii++) {
          this.chosenJenisTtds[ii].flag_visual = false
      }
      // set Id and file path of selected jenis ttd
      for(var jj = 0; jj < this.chosenIdJenisTtds.length; jj++) {
          let item = this.chosenIdJenisTtds[jj]
          let filePath = null
          let itemId = null
          if (item == 1) {
              itemId = this.organisasi.trim().replaceAll(' ', '_') + '_organisasi'
              filePath = await this.loadBase64File(stampPath + '/' + this.fileStampOrganisasi)
          } else if(item == 2) {
              itemId = "QRCode"
              filePath = qrPlaceHolder
          } else {
              itemId = "DeskripsiQR"
              filePath = bsreDisclaimer
          }
          for(var ii = 0; ii < this.chosenJenisTtds.length; ii++) {
              if(item + '' === this.chosenJenisTtds[ii].id_jenis_ttd + '') {
                  this.chosenJenisTtds[ii].flag_visual = true
                  this.chosenJenisTtds[ii].id = itemId
                  this.chosenJenisTtds[ii].filePath = filePath
              }
          }
      }
    },
    // drag and drop related
    async loadBase64File(path) {
      var base64 = ""
      await apiServer
          .get("/files/get-base64-image?target_path="+path)
          .then(response => {
              base64 = response.data.data
          })
          .catch(error => {
              console.log("There was an error:", error.response.data.message); // Logs out the error
          });
      return base64
    },
    async fillKoordinatTtdItems() {
      //loop ttd_jenis_dokumen
      await this.arsip.ttd_arsip_dokumen.forEach((item, index) => {
          //alert(JSON.stringify(item))
          // if the item is of pemaraf
          // use username_paraf to find element in ttdItems
          // fill koordinat in ttdItems from ttd_jenis_dokumen
          if (item.tipe_ttd == 1 && item.flag_visual) {
              var element = this.findElementById(item.pengguna.username + '_paraf', this.imagePdfItems)
              element.koordinat = JSON.parse(item.koordinat)
              element.page = item.halaman
          }
          // if the item is of penandatangan
          // use username_ttd to find element in ttdItems
          // fill koordinat in ttdItems from ttd_jenis_dokumen
          if (item.tipe_ttd == 2 && item.flag_visual) {
              var element = this.findElementById(item.pengguna.username + '_ttd', this.imagePdfItems)
              element.koordinat = JSON.parse(item.koordinat)
              element.page = item.halaman
          }
      });

      await this.arsip.jenis_ttd_arsip_dokumen.forEach((item, index) => {
        var chosenJenisTtd = null
        for(var ii = 0; ii < this.chosenJenisTtds.length; ii++) {
            if(this.chosenJenisTtds[ii].id_jenis_ttd == item.id_jenis_ttd) {
                chosenJenisTtd =  this.chosenJenisTtds[ii]
            }
        }
        if(chosenJenisTtd) {
            var element = this.findElementById(chosenJenisTtd.id, this.imagePdfItems)
            element.koordinat = JSON.parse(item.koordinat)
            element.page = item.halaman
        }
      });
    },
    async convertPdfToBase64(blob) {
      return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
      });
    },
  }
};
</script>
<style scoped>
/* Signer passphrase: field and actions on one line, stacked on phones */
.esign-sign-form {
  margin-top: 8px;
}

.esign-sign-form__row {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 640px;
}

.esign-sign-form__row .v-text-field {
  flex: 1 1 auto;
}

@media (max-width: 600px) {
  .esign-sign-form__row {
    flex-wrap: wrap;
  }

  .esign-sign-form__row .v-text-field {
    flex-basis: 100%;
  }

  .esign-sign-form__row .v-btn {
    flex: 1 1 0;
  }
}
</style>
